
import {formatArea, formatCurrency} from "../utils/functions";

import OverlayWind from "../classes/OverlayWind";
import OverlayNoise from "../classes/OverlayNoise";
import OverlayShadow from "../classes/OverlayShadow";

const overlayMaps = {
	user: null,
	defaultOverlay : "wind",
	overlays : [
		{
			label:"wind",
			value:'wind',
			thumbnail:'overlay_wind.png',
			handler: new OverlayWind(),
			
			
		},
		{
			label:"noise",
			value:'noise',
			thumbnail:'overlay_noise.png',
			handler: new OverlayNoise(),
			
			
		},
		{
			label:"shadow",
			value:'shadow',
			thumbnail:'overlay_shadow.png',
			handler: new OverlayShadow(),
			
			
		}
		
		
	],
	"get": function(overlay){
		var idx = -1;
		if((idx = this.overlays.findIndex((w)=>w.value == overlay)) != -1 ){
			
			return this.overlays[idx];
		}
		else
			return this.overlays[1];
	}
	
}





export { overlayMaps};


